import * as React from "react";

// import { faLanguage } from "@fortawesome/free-solid-svg-icons";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Toggle from "../../../../common/controls/toggle";
// import { min } from "moment";
// import { translate } from "../../../../locales/utils";
import { useState } from "react";
import { useTranslate } from "../../../../locales/hooks";

type SwitcherState = "mini-cv" | "skills";

interface ILanguageSwitcherProps {
  SwitchState: SwitcherState;
  onSwitching?: (switchState: SwitcherState) => void;
}

const RightSwitcher: React.FunctionComponent<ILanguageSwitcherProps> = ({
  SwitchState: InitialSwitchState = "mini-cv",
  onSwitching,
}) => {
  const [isOn, setIsOn] = useState<boolean>(InitialSwitchState === "skills");
  const t = useTranslate();

  return (
    <div
      className="flex flex-row gap-2 items-center justify-center"
      data-name="menu-right-switcher"
    >
      {/* <div className="flex flex-1 flex-col items-center justify-center px-[20px]"> */}

      <div className={`order-first ${isOn ? "opacity-50" : "opacity-100"}`}>
        <p className="font-['Hind',sans-serif] text-[12px]">
          {t("MiniCvLabel")}
        </p>
      </div>
      <div className="">
        <Toggle
          enabled={isOn}
          onToggle={(enabled) => {
            setIsOn(enabled);
            if (typeof onSwitching == "undefined") {
              return;
            }
            onSwitching(enabled ? "skills" : "mini-cv");
          }}
          size="extraSmall"
        />
      </div>
      <div className={`order-last ${isOn ? "opacity-100" : "opacity-50"}`}>
        <p className="font-['Hind',sans-serif] text-[12px]">
          {t("SkillsLabel")}
        </p>
      </div>
    </div>
  );
};

export default RightSwitcher;
export type { SwitcherState };
